<template>
    <div
        v-if="isOpen"
        class="modal fade show"
        style="display: block; background: #1c1d1c33"
    >
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                    <h4 class="mb-0">Generate Tax Certificate</h4>
                    <button
                        @click="toggleModal"
                        type="button"
                        class="btn-close"
                        aria-label="Close"
                    ></button>
                </div>
                <hr class="mt-0">
                <div class="px-2 pb-2">
                    <div class="mb-2">
                        <label class="form-label">Issue Date</label>
                        <input type="date" class="form-control" v-model="formData.date">
                    </div>
                    <template v-if="showPeriodAndIssuer">
                        <div class="mb-2">
                            <label class="form-label">From Date</label>
                            <input type="date" class="form-control" v-model="formData.from_date">
                        </div>
                        <div class="mb-2">
                            <label class="form-label">To Date</label>
                            <input type="date" class="form-control" v-model="formData.to_date">
                        </div>
                        <div class="mb-2">
                            <label class="form-label">Issued By</label>
                            <AsyncSelect
                                placeholder="Select Issued By"
                                v-model="issuedBy"
                                :api-service="fetchContactProfiles"
                                :format-label="formatPatientLabel"
                                :additional-query="{ roles: 'employee' }"
                            />
                        </div>
                    </template>
                    <div class="text-center">
                        <hr class="mt-2">
                        <button
                            :disabled="loading"
                            @click="submit"
                            class="btn btn-primary me-1 waves-effect waves-float waves-light"
                        >
                            <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                            Generate
                        </button>
                        <button @click="toggleModal" class="btn btn-outline-secondary waves-effect">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import AsyncSelect from '@/components/molecule/input-field/AsyncSelect.vue';
import handleContact from '@/services/modules/contact';
import { useAsyncDropdownHelper } from '@/services/utils/asyncDropdownHelper';

const props = defineProps({
    formData: {
        type: Object,
        required: true
    },
    showPeriodAndIssuer: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['onSubmit']);

const { fetchContactProfiles } = handleContact();
const { formatPatientLabel } = useAsyncDropdownHelper();

const isOpen = ref(false);
const loading = ref(false);
const issuedBy = ref(null);

watch(issuedBy, (newValue) => {
    if (!newValue) {
        props.formData.contact_profile_id = null;
        return;
    }
    props.formData.contact_profile_id = newValue.id;
});

onMounted(() => {
    const today = new Date().toISOString().split('T')[0];
    if (!props.formData.date) props.formData.date = today;
    if (!props.formData.from_date) props.formData.from_date = today;
    if (!props.formData.to_date) props.formData.to_date = today;
});

const toggleModal = () => {
    isOpen.value = !isOpen.value;
    if (!isOpen.value) issuedBy.value = null;
};

const submit = () => {
    emit('onSubmit');
};

defineExpose({ toggleModal, loading });
</script>
